// extracted by mini-css-extract-plugin
export default {"card":"styles_card__ui+ds","active":"styles_active__CTfki"};